import { MSW_SERVICE_KEY } from '@/constants/config';
import axios from 'axios';
import { Alert, Notification } from 'rsuite';
import { HttpStatus } from '@hypers/types';
import { ls } from '@/utils/db'
import _ from 'lodash';
import { SERVICE_STATUS } from './constants';

const request = axios.create();
request.interceptors.request.use(
  (config) => {
    // 过滤无效的组合参数
    if (config.params) {
      if (!config.params.search) {
        delete config.params.search;
        delete config.params.filterColumn;
      }
      if (!config.params.orderColumn) {
        delete config.params.orderColumn;
        delete config.params.orderType;
      }
      if (!config.params.page) {
        delete config.params.page;
        delete config.params.pageSize;
      }
    }

    return config;
  },
  (thrown) => {
    Alert.error(`${thrown.config.method === 'get' ? '请求' : '操作'}失败`);
  }
);

/**
 * 是否 503 正在维护
 */
let maintenance = false;

request.interceptors.response.use(
  (response) => {
    if (maintenance) {
      maintenance = false;
    }

    // 比斯特GWC状态码 200000请求成功
    if (response.data.status !== SERVICE_STATUS.SUCCESS) {
      if (response.data.msg || response.data.message) {
        Alert.error(response.data.msg || response.data.message);
        // 200400未登录
        if (response.data.status === SERVICE_STATUS.NOT_AUTH) {
          ls.remove(MSW_SERVICE_KEY)
          // 非登录页200400时重载页面
          if (!window.location.pathname.includes('/login')) {
            window.location.reload();
          }
        }
      } else {
        Alert.error('操作失败');
      }
      return response;
    }

    if (response.status === HttpStatus.Accepted) {
      if (response.data.message) {
        Alert.success(response.data.message);
      }
    }
    return response;
  },
  (thrown) => {
    if (thrown.response?.status === 503) {
      if (!maintenance) {
        maintenance = true;
        Notification.warning({
          title: `${thrown.response?.status} ${thrown.response?.statusText}`,
          description: '服务维护中，请稍后再试',
          duration: 5000,
        });
      }
    } else if (thrown.response?.status === 504) { // 请求超时
      window.location.reload();
    } else if (thrown.response?.status === 401) {
      const targetUrl = thrown.response?.data?.url;
      if (targetUrl) {
        location.href = targetUrl;
      }
      return thrown.response;
    } else if (thrown.response?.status === 422) {
      thrown.formError = Object.entries(thrown.response?.data?.fields).reduce(
        (formErrors, [field, errors]: [string, { code: string; message: string }[]]) => {
          return {
            ...formErrors,
            [field]: errors[0].message,
          };
        },
        {}
      );
    } else if (
      thrown.response?.status >= 400 &&
      thrown.response?.status < 500 &&
      thrown.response?.status !== 404
    ) {
      Alert.error(thrown.response?.data?.message);
    } else {
      Notification.error({
        title: `${thrown.response?.status} ${thrown.response?.data?.message ?? thrown.response?.statusText
          }`,
        description: `${_.toUpper(thrown.config.method)} ${thrown.config.url}`,
      });
    }
    throw thrown;
  }
);

export default request;


export const { isCancel } = axios;

export enum FETCH_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

const generateFetchFunction =
  (method: FETCH_METHOD) =>
    (url: string, options?: any): Promise<any> =>
      request(url, {
        ...options,
        method,
      }).catch((error: any) => {
        // cancel 的请求不需要报错
        if (isCancel(error)) {
          return null;
        }
        return Promise.reject(error);
      });

export const GET = generateFetchFunction(FETCH_METHOD.GET);
export const POST = generateFetchFunction(FETCH_METHOD.POST);
export const PATCH = generateFetchFunction(FETCH_METHOD.PATCH);
export const PUT = generateFetchFunction(FETCH_METHOD.PUT);
export const DELETE = generateFetchFunction(FETCH_METHOD.DELETE);
